import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/edit/matchbrackets'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/lint/json-lint'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/merge/merge'
import 'codemirror/addon/search/search'
import 'codemirror/lib/codemirror'
import 'codemirror/mode/clike/clike'
import 'codemirror/mode/groovy/groovy'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/python/python'
import diff_match_patch from 'diff-match-patch'
import { attachLogger } from 'effector-logger'
import { enableMapSet } from 'immer'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { loadRuntimeConfig } from './app/runtime-config.loader'
import { environment } from './environments/environment'

declare global {
  interface Window {
    diff_match_patch: typeof diff_match_patch
    DIFF_DELETE: number
    DIFF_INSERT: number
    DIFF_EQUAL: number
  }
}

window.diff_match_patch = diff_match_patch
window.DIFF_DELETE = diff_match_patch.DIFF_DELETE
window.DIFF_INSERT = diff_match_patch.DIFF_INSERT
window.DIFF_EQUAL = diff_match_patch.DIFF_EQUAL

enableMapSet()

if (environment.production) {
  enableProdMode()
}

if (environment.debug?.effector) {
  attachLogger()
}

loadRuntimeConfig()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err))

// dummy change to trigger CI

// dummy change to trigger a CI run
